import React, {useEffect} from 'react';
import $ from "jquery";

function MaterialNewModalTable(props) {

    useEffect(() => {
        $('#newMaterialTable').DataTable({
            dom: 'frtilp', language: {
                fontcolor: 'white', url: 'https://cdn.datatables.net/plug-ins/1.10.24/i18n/German.json' // German Language - DataTable Plugin
            }, oLanguage: {
                sSearch: '', searchPlaceholder: 'Suchen'
            }, "paging": true, "pageLength": 5
        });
    }, []);

    function handleNewMaterialClick(item) {
        if (props.taetigkeitsberichtData.material.find(i => (i.id===item.id && i.position === item.position &&
        i.description === item.description)) === undefined) {
            let tdata = props.taetigkeitsberichtData
            tdata.material.push({
                "id": item.id, "position": item.position, "description": item.description, "menge": "",
                "unit": item.unit,"source":"LV",
                "aufmas":""
            })
            props.setTaetigkeitsberichtData(tdata)
            props.setShow(false)
        } else {
            alert("Es ist schon da!")
        }

    }

    function getAddMaterialTableBody(matData) {
       let result = matData
        //let result = newMaterialData.filter(md =>
          //   props.taetigkeitsberichtData.material.every(fd => (fd.id !== md.id && fd.position !== md.position
            //     && fd.description !== md.description)))


        //return newMaterialData?.map((item) => (

            return result?.map((item) => (
                <tr key={item.id}
                    onClick={() => handleNewMaterialClick(item)}>
                <td>{item.position}</td>
                <td>{item.description}</td>
            </tr>
                ));
    }

    return (
        <div >
        <table id="newMaterialTable" className="table handwai-white-text">
            <thead>
            <tr>
                <th>LV Position</th>
                <th>Kurztext</th>
            </tr>
            </thead>
            <tbody>{getAddMaterialTableBody(props.newMaterialData)}</tbody>
        </table>
    </div>

    );
}

export default MaterialNewModalTable;
